import React from 'react';
import { IconImg } from '../index';
import locationIcon from './location.svg';
import dateIcon from './calendar.svg';
import downIcon from './down.svg';

export const LocationIcon = () => <IconImg src={locationIcon} alt="" />;
export const DateIcon = () => <IconImg src={dateIcon} alt="" />;
export const DownIcon = () => <IconImg src={downIcon} alt="" />;
